// GAA county picker (Gaelic mystery box) — accordion, selection pills and the
// disabled state once three counties are picked. The checkboxes share
// name="nations_leagues" with the football picker, so products-anywhere.js still
// owns the hard max-3 limit and the write into the cart form; this file only
// makes the GAA version nicer to use.
(function () {
  const MAX = 3;

  function init(root) {
    const form = root.closest("form");
    const boxes = Array.from(root.querySelectorAll('input[name="nations_leagues"]'));
    const picks = root.querySelector("[data-gaa-picks]");
    const counter = document.querySelector("[data-gaa-counter]");

    // Liquid cannot sort metaobjects by a field, so order each province's
    // counties by sort_order here.
    root.querySelectorAll(".gaa-province__grid").forEach((grid) => {
      Array.from(grid.children)
        .sort((a, b) => (Number(a.dataset.sort) || 99) - (Number(b.dataset.sort) || 99))
        .forEach((el) => grid.appendChild(el));
    });

    root.querySelectorAll(".gaa-province__head").forEach((head) => {
      head.addEventListener("click", () => {
        const open = head.getAttribute("aria-expanded") === "true";
        head.setAttribute("aria-expanded", String(!open));
        head.closest(".gaa-province").classList.toggle("is-open", !open);
      });
    });

    const chipFor = (box) => {
      const chip = box.parentNode.querySelector(".gaa-chip");
      return chip ? chip.outerHTML : "";
    };
    const attr = (s) => s.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");

    function sync() {
      const checked = boxes.filter((b) => b.checked);
      const full = checked.length >= MAX;

      boxes.forEach((b) => {
        const off = full && !b.checked;
        b.disabled = off;
        b.closest(".gaa-county").classList.toggle("is-disabled", off);
      });

      root.querySelectorAll(".gaa-province").forEach((section) => {
        const selected = section.querySelectorAll("input:checked").length;
        const total = section.querySelectorAll('input[name="nations_leagues"]').length;
        const meta = section.querySelector("[data-gaa-meta]");
        if (meta) {
          meta.innerHTML =
            total + " counties" + (selected ? " &middot; <b>" + selected + " selected</b>" : "");
        }
      });

      if (picks) {
        picks.innerHTML = checked
          .map(
            (b) =>
              '<span class="gaa-pick">' +
              chipFor(b) +
              "<span>" + attr(b.value) + "</span>" +
              '<button type="button" data-gaa-remove="' + attr(b.value) + '" aria-label="Remove ' +
              attr(b.value) + '">&times;</button></span>'
          )
          .join("");
      }

      if (counter) counter.textContent = checked.length + "/" + MAX;
    }

    boxes.forEach((b) => b.addEventListener("change", sync));

    if (picks) {
      picks.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-gaa-remove]");
        if (!btn) return;
        const box = boxes.find((b) => b.value === btn.getAttribute("data-gaa-remove"));
        if (box) {
          box.checked = false;
          sync();
        }
      });
    }

    // products-anywhere.js resets this form every time the modal opens; the
    // reset lands after the event fires, so re-sync on the next tick.
    if (form) {
      form.addEventListener("reset", () => {
        setTimeout(() => {
          root.querySelectorAll(".gaa-province.is-open").forEach((section) => {
            section.classList.remove("is-open");
            section.querySelector(".gaa-province__head").setAttribute("aria-expanded", "false");
          });
          sync();
        }, 0);
      });
    }

    sync();
  }

  function boot() {
    document.querySelectorAll("#gaa-county-picker").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
